export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;
